var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRankingArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 5.575L6.275 9.475C6.45833 9.65833 6.55 9.89167 6.55 10.175C6.55 10.4583 6.45833 10.6917 6.275 10.875C6.09167 11.0583 5.85833 11.15 5.575 11.15C5.29167 11.15 5.05833 11.0583 4.875 10.875L0.275 6.275C0.175 6.175 0.104167 6.06667 0.0625 5.95C0.0208333 5.83333 0 5.70833 0 5.575C0 5.44167 0.0208333 5.31667 0.0625 5.2C0.104167 5.08333 0.175 4.975 0.275 4.875L4.875 0.275C5.05833 0.0916667 5.29167 0 5.575 0C5.85833 0 6.09167 0.0916667 6.275 0.275C6.45833 0.458333 6.55 0.691667 6.55 0.975C6.55 1.25833 6.45833 1.49167 6.275 1.675L2.375 5.575Z",
    fill: "#1B4B86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankingArrowLeft);
export default __webpack_public_path__ + "static/media/icon_ranking_arrow_left.acf9e77b9977de96592144054cfd150c.svg";
export { ForwardRef as ReactComponent };